import * as React from "react";
import cn from "classnames";
import { useField } from "formik";
import styles from "./styles.module.scss";

interface IProps {
    name: string;
    label: string;
    showValidationErrorWhenNotTouched?: boolean;
}

export function FormLabel({
    name,
    label,
    showValidationErrorWhenNotTouched = false,
}: IProps): JSX.Element {
    const [, meta] = useField<string>(name);
    const hasError = Boolean(
        meta.error && (showValidationErrorWhenNotTouched || meta.touched),
    );
    return (
        <label className={cn(styles.wrapper, hasError && styles.hasError)}>
            <div className={styles.labelAndErrorWrapper}>
                <div className={styles.label}>{label}</div>
                {hasError && <div className={styles.error}>{meta.error}</div>}
            </div>
        </label>
    );
}
